import { observer } from 'mobx-react-lite';

import type { DirectionalDrillingState } from '../store/DirectionalDrillingState';

import { Aim } from './Aim';
import { ToolRender } from './ToolRender';

interface Props {
  width: number;
  height: number;
  widgetState: DirectionalDrillingState;
}

export const ToolChart = observer(function ToolChart({ width, height, widgetState }: Props) {
  return (
    <>
      <Aim
        theme={widgetState.appParams.theme}
        width={width}
        height={height}
        is360={widgetState.is360}
        pixelRatio={window.devicePixelRatio}
      />
      {widgetState.gravityToolState && (
        <ToolRender
          theme={widgetState.appParams.theme}
          width={width}
          height={height}
          toolState={widgetState.gravityToolState}
          pixelRatio={window.devicePixelRatio}
        />
      )}
      {widgetState.magneticToolState && (
        <ToolRender
          theme={widgetState.appParams.theme}
          width={width}
          height={height}
          toolState={widgetState.magneticToolState}
          pixelRatio={window.devicePixelRatio}
        />
      )}
    </>
  );
});
